/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiMessage } from '../../asyncapi/models/AaiMessage';
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { Aai20NodeFactory } from '../../asyncapi/v2/models/Aai20NodeFactory';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Document } from '../../core/models/Document';
import { AaiComponents } from '../../asyncapi/models/AaiComponents';
import { Node } from '../../core/models/Node';

/**
 * A command used to remove a message definition item in an AsyncAPI document.
 * @author laurent.broudoux@gmail.com
 * @param {string} name
 * @class
 * @extends AbstractCommand
 */
export class DeleteMessageDefinitionCommand extends AbstractCommand {
    public _name : string;

    public _oldDefinition : any;

    public constructor(name? : any) {
        if(((typeof name === 'string') || name === null)) {
            let __args = arguments;
            super();
            if(this._name===undefined) this._name = null;
            if(this._oldDefinition===undefined) this._oldDefinition = null;
            if(this._name===undefined) this._name = null;
            if(this._oldDefinition===undefined) this._oldDefinition = null;
            (() => {
                this._name = name;
            })();
        } else if(name === undefined) {
            let __args = arguments;
            super();
            if(this._name===undefined) this._name = null;
            if(this._oldDefinition===undefined) this._oldDefinition = null;
            if(this._name===undefined) this._name = null;
            if(this._oldDefinition===undefined) this._oldDefinition = null;
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteMessageDefinitionCommand] Executing.");
        let doc20 : Aai20Document = <Aai20Document>document;
        if(ModelUtils.isDefined(doc20.components)) {
            let msgDef : AaiMessage = doc20.components.removeMessage(this._name);
            this._oldDefinition = Library.writeNode(msgDef);
        }
    }

    /**
     * 
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteMessageDefinitionCommand] Reverting.");
        if(this.isNullOrUndefined(this._oldDefinition)) {
            return;
        }
        let doc20 : Aai20Document = <Aai20Document>document;
        if(ModelUtils.isDefined(doc20.components)) {
            let factory : Aai20NodeFactory = new Aai20NodeFactory();
            let msgDef : AaiMessage = factory.createMessage(doc20.components, this._name);
            Library.readNode(this._oldDefinition, msgDef);
            doc20.components.addMessage(this._name, msgDef);
        }
    }
}
DeleteMessageDefinitionCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteMessageDefinitionCommand";
DeleteMessageDefinitionCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




